import React, { Component } from 'react'
import './index.css'
import IconClose from "../IconClose";
import { fontColourCalculator } from '../../slice/lucket-model/model';
import { Tooltip } from '@mui/material';
import { STATUS_OPTION, STATUS_OPTION_HEX_PALLETE, statusOptions } from '../../constants';

const colorFloatClass = (color) => "LucketActionStatusIcon statusfloat-" + color;

class LucketActionStatusIcon extends Component {

    state = {
        edit: false
    }


    edit = () => {
        if (this.state.edit === false) {
            this.setState({ edit: true })
        } else {
            this.setState({ edit: false })
        }

    }

    set = (event, v) => {
        event.stopPropagation();
        this.setState({ edit: false });
        this.props.updateLucket(v, "actionStatus", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
    }

    setPoints = (event, v) => {
        event.stopPropagation();
        if (v === "plus") {
            let lucket = this.props.lucket;
            if (Number(lucket.points) < 25) {
                let numPoint = Number(lucket.points);

                numPoint += 1;
                this.props.updateLucket(numPoint, "points", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
            }
        }
        if (v === "minus") {
            let lucket = this.props.lucket;
            if (Number(lucket.points) > 1) {
                let numPoint = Number(lucket.points);
                numPoint -= 1;
                this.props.updateLucket(numPoint, "points", this.props.childLucket && this.props.lucket, this.props.childLucketIndex);
            }
        }
    }

    render() {

        // Safety check: ensure lucket and actionStatus exist
        if (!this.props.lucket || !this.props.lucket.actionStatus) {
            return null;
        }

        return (<Tooltip title="Action Status Icon" placement='top'>
            <div id={"actionStatus" + this.props.lucket.rowID}
                className={'LucketActionStatusIcon'}
                onClick={this.edit}
                style={{
                    color: fontColourCalculator(this.props.lucket.actionStatus),
                    backgroundColor: STATUS_OPTION_HEX_PALLETE[this.props.lucket.actionStatus]
                }}
            >
                {this.props.lucket.points}

                {(this.state.edit === true) ?
                    <div className="ActionStatusEditorWrapper">
                        <div className="ActionStatusCallout" />
                        <div className="ActionStatusMenu">
                            {statusOptions.filter(
                                o => o !== this.props.lucket.actionStatus
                            ).map(o =>
                                <div key={o} className={'LucketActionStatusIcon ' + 'statusfloat'}
                                    style={{ backgroundColor: STATUS_OPTION_HEX_PALLETE[o] }}
                                    onClick={(e) => this.set(e, o)} />
                            )}

                            <div key={"minus"} className={'LucketActionStatusIcon ' + colorFloatClass("minus")}
                                onClick={(e) => this.setPoints(e, "minus")} >
                                <img src={"/images/minus.svg"} className="ActionStatusImage" alt="minus.svg" />
                            </div>


                            <div key={"plus"} className={'LucketActionStatusIcon ' + colorFloatClass("plus")}
                                onClick={(e) => this.setPoints(e, "plus")} >
                                <img src={"/images/add.svg"} className="ActionStatusImage" alt="add.svg" />
                            </div>

                            <IconClose edit={this.edit} key={"close"} />

                        </div> </div> : null}


            </div>
        </Tooltip >)
    }

}

export default LucketActionStatusIcon